import { config } from "../config/firebase";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/messaging";
firebase.initializeApp(config);

export const firebaseApp = firebase;
